import { uid } from "../../lib/format";

export const SHAPE_TYPES = {
  pipe: { label: "Straight pipe", dims: { length: 1000, diameter: 50 } },
  bend: { label: "90° bend", dims: { legA: 400, legB: 400, diameter: 50 } },
  tee: { label: "T-junction", dims: { length: 600, branch: 300, diameter: 50 } },
  rect: { label: "Rectangle", dims: { width: 1200, height: 600 } },
  circle: { label: "Circle", dims: { diameter: 400 } },
};

export const DIM_LABELS = {
  length: "Length (mm)", diameter: "Diameter Ø (mm)", legA: "Leg A (mm)", legB: "Leg B (mm)",
  branch: "Branch (mm)", width: "Width (mm)", height: "Height (mm)",
};

export const newShape = (type, x = 200, y = 200) => ({
  id: uid(), type, x, y, rotation: 0, label: "", dims: { ...SHAPE_TYPES[type].dims },
});

export function shapeToLineItem(s) {
  const d = s.dims;
  const name = s.label ? `${s.label} – ` : "";
  const base = { id: uid(), quantity: 1, length: 0, width: 0, unit_price: 0 };
  switch (s.type) {
    case "pipe":
      return { ...base, description: `${name}Pipe Ø${d.diameter}mm × ${d.length}mm`, pricing_type: "length", length: d.length / 1000 };
    case "bend":
      return { ...base, description: `${name}90° bend Ø${d.diameter}mm, legs ${d.legA} × ${d.legB}mm`, pricing_type: "length", length: (d.legA + d.legB) / 1000 };
    case "tee":
      return { ...base, description: `${name}T-junction Ø${d.diameter}mm, run ${d.length}mm, branch ${d.branch}mm`, pricing_type: "each" };
    case "rect":
      return { ...base, description: `${name}Panel ${d.width} × ${d.height}mm`, pricing_type: "area", length: d.width / 1000, width: d.height / 1000 };
    default:
      return { ...base, description: `${name}Circle Ø${d.diameter}mm`, pricing_type: "each" };
  }
}
